import {createHash} from "crypto"

export function useAvatarUrl(email?: string) {
  if (!email) return "https://www.gravatar.com/avatar"
  const normalizedEmail = email.trim().toLowerCase();
  const hash = createHash('md5').update(normalizedEmail).digest('hex');
  return `https://www.gravatar.com/avatar/${hash}`;
}
